import {
  Card,
  CardErrorBoundaryWithSpinfinity,
  DesignButton,
  Typography,
} from 'components';
import { useLocation, useNavigate } from 'react-router-dom';
import ConditionMetricsBoxes from './ConditionMetricsBoxes';

export function ConditionMetricsGridCard() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  function handleNavigate() {
    navigate(`${pathname}/conditions/metrics`, { state: { from: pathname } });
  }

  return (
    <CardErrorBoundaryWithSpinfinity cardName='ConditionMetricsGridCard'>
      <Card title='Condition associations'>
        <Typography variant='body-s'>
          This section helps you explore which metrics are commonly associated
          with different symptoms or conditions. This is not a diagnosis.
        </Typography>
        <ConditionMetricsBoxes />
        <DesignButton color='purple' width='full' onClick={handleNavigate}>
          View all health associations
        </DesignButton>
      </Card>
    </CardErrorBoundaryWithSpinfinity>
  );
}
